module.exports = new __parcel__URL__("empty-add-item-darkmode.3ed103f2.svg").toString();